import { render, staticRenderFns } from "./subspecialties.vue?vue&type=template&id=5b4da5e7"
import script from "./subspecialties.vue?vue&type=script&lang=js"
export * from "./subspecialties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports